import { ReputationChart } from '@/components/charts/reputationChart'
import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'
import { NOT_RATED_REASON, shouldShowNotRatedReputation } from '@/utils/reputationRating'
import { ReputationBreakdown } from './reputationBreakdown'

interface Props {
  vault: Vault
  className?: string
}

export const StrategyReputation = ({ vault, className }: Props) => {
  const { score } = vault

  if (!score) {
    return null
  }

  const isNotRated = shouldShowNotRatedReputation(vault)

  return (
    <div className={cn('flex flex-col gap-4', className)}>
      <div className="mx-auto">
        <ReputationChart score={score} isNotRated={isNotRated} />
      </div>
      <div className="mx-auto w-full max-w-sm">
        {isNotRated && <p className="mb-4 text-center text-disabled text-sm">{NOT_RATED_REASON}</p>}
        <ReputationBreakdown vault={vault} score={score} />
      </div>
    </div>
  )
}
